// DS: DS6.1 - Option Semantics (for use in select-style menus)
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import ListItemContent from '../../legos/ListItemContent';
import { EffectStrength, useListItem } from '../../common';
/**
 * This is a ListItem with `role="option"` semantics. We expect it to be contained in an element with `role="combobox"`,
 * so only use this if you know how that works (https://w3c.github.io/aria/#combobox).
 */ const ListItemOption = (unfilteredProps)=>{
    const _useListItem = useListItem(unfilteredProps, {
        checked: EffectStrength.Weak
    }), { rootProps: { checked }, contentProps } = _useListItem, restRootProps = _object_without_properties(_useListItem.rootProps, [
        "checked"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        role: "option",
        "aria-selected": checked
    }, restRootProps), /*#__PURE__*/ React.createElement(ListItemContent, contentProps));
};
ListItemOption.displayName = 'ListItemOption';
export default ListItemOption;

//# sourceMappingURL=ListItemOption.js.map